module.exports = __webpack_public_path__ + "assets/ai-role-play-inactive.30ab5b4a.svg";